"use strict";

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tooltip = exports.Affix = exports.StyledPopover = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var _1 = require(".");

function StyledPopover(_a) {
  var className = _a.className,
      rest = __rest(_a, ["className"]);

  return react_1["default"].createElement(antd_1.Popover, Object.assign({}, rest, {
    overlayClassName: className
  }));
}

exports.StyledPopover = StyledPopover;

function Affix(_a) {
  var offsetTop = _a.offsetTop,
      offsetBottom = _a.offsetBottom,
      noDiv = _a.noDiv,
      children = _a.children,
      rest = __rest(_a, ["offsetTop", "offsetBottom", "noDiv", "children"]);

  var theme = react_1["default"].useContext(_1.StyledThemeContext);
  var top = offsetTop === true ? theme['@size-l'] : typeof offsetTop === 'string' ? theme[offsetTop] : undefined;
  var bottom = offsetBottom === true ? theme['@size-l'] : typeof offsetBottom === 'string' ? theme[offsetBottom] : undefined;
  var content = noDiv ? children : react_1["default"].createElement("div", {
    children: children
  });
  return react_1["default"].createElement(antd_1.Affix, Object.assign({}, rest, {
    offsetTop: top ? parseFloat(top.replace('px', '')) : undefined,
    offsetBottom: bottom ? parseFloat(bottom.replace('px', '')) : undefined,
    children: content
  }));
}

exports.Affix = Affix;

function Tooltip(rest) {
  return react_1["default"].createElement(antd_1.Tooltip, Object.assign({
    mouseEnterDelay: 1
  }, rest));
}

exports.Tooltip = Tooltip;